import React, { useCallback } from "react";
import { Image, Form } from "semantic-ui-react";
import { useFormik } from "formik";
import { initialValues, validationSchema } from "./UserForm.form";
import { User } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { image } from "../../../../assets";
import { useDropzone } from "react-dropzone";
import "./UserForm.scss";

const userController = new User();

export function UserForm(props) {
  const { close, onReload, user } = props;
  const { accessToken } = useAuth();
  const roleOptions = [
    { key: "admin", value: "admin", text: "Administrador" },
    { key: "user", value: "user", text: "Usuario" },
    { key: "client", value: "client", text: "Cliente" },
    { key: "partner", value: "partner", text: "Partner" },
    { key: "teacher", value: "teacher", text: "Profesor" },
    { key: "student", value: "student", text: "Alumno" },
  ];

  const formik = useFormik({
    initialValues: initialValues(user),
    validationSchema: validationSchema(user),
    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        if (!user) {
          await userController.createUser(accessToken, formValue);
        } else {
          if (formik.values.fileAvatar && user.avatar) {
            await userController.deleteAvatar(accessToken, user.avatar);
          }
          await userController.updateUser(accessToken, user._id, formValue);
        }
        onReload();
        close();
      } catch (error) {
        console.error("Error during form submission:", error);
      }
    },
  });
 
  const onDrop = useCallback((acceptedFiles) => {
    const file = acceptedFiles[0];
    if (file) {
      const validMimeTypes = ["image/jpeg", "image/png"];
      if (validMimeTypes.includes(file.type)) {
        formik.setFieldValue("avatar", URL.createObjectURL(file));
        formik.setFieldValue("fileAvatar", file);
      } else {
        console.error("Invalid file format or type.");
      }
    }
  }, [formik]);

  const { getRootProps, getInputProps } = useDropzone({
    accept: {
      'image/jpeg': ['.jpeg', '.jpg'],
      'image/png': ['.png'],
    },
    onDrop,
    multiple: false,
  });

  const getAvatar = () => {
    if (formik.values.fileAvatar) {
      return formik.values.avatar;
    } else if (formik.values.avatar) {
      return `${formik.values.avatar}`;
    }
    return image.noAvatar;
  };

  return (
    <Form className="user-form" onSubmit={formik.handleSubmit}>
      <div className="user-form__avatar" {...getRootProps()}>
        <input {...getInputProps()} />
        <Image avatar size="small" src={getAvatar()} />
      </div>
      <Form.Group widths="equal">
        <Form.Input
          name="firstname"
          placeholder="Nombre"
          onChange={formik.handleChange}
          value={formik.values.firstname}
          error={formik.errors.firstname}
        />
        <Form.Input
          name="lastname"
          placeholder="Apellidos"
          onChange={formik.handleChange}
          value={formik.values.lastname}
          error={formik.errors.lastname}
        />
      </Form.Group>
      <Form.Group widths="equal">
        <Form.Input
          name="email"
          placeholder="Correo electrónico"
          onChange={formik.handleChange}
          value={formik.values.email}
          error={formik.errors.email}
        />
        <Form.Dropdown
          placeholder="Selecciona un rol"
          options={roleOptions}
          selection
          onChange={(e, data) => formik.setFieldValue("role", data.value)}
          value={formik.values.role}
          error={formik.errors.role}
        />
      </Form.Group>

      {/* Mostrar idClient solo si el rol seleccionado es 'client' */}
      {formik.values.role === 'client' && (
        <Form.Input
          type="idClient"
          name="idClient"
          placeholder="ID del Cliente si tiene BBDD"
          onChange={formik.handleChange}
          value={formik.values.idClient}
          error={formik.errors.idClient}
        />
      )}

      <Form.Input
        type="password"
        name="password"
        placeholder="Contraseña"
        onChange={formik.handleChange}
        value={formik.values.password}
        error={formik.errors.password}
      />
      <Form.Button type="submit" primary fluid loading={formik.isSubmitting}>
        {user ? "Actualizar usuario" : "Crear usuario"}
      </Form.Button>
    </Form>
  );
}
